$("#bundleProduct").submit(function(e) {
    e.preventDefault();
    var $addToCartForm = $(this);
    var $addToCartBtn = $addToCartForm.find('.bundle_ATC');
    var dataBundlePrice = $(this).attr("data-bundle-price")
    var dataBundleCompareAtPrice = $(this).attr("data-bundle-compareAtPrice")
    let bundleTitle = $(this).attr("data-bundle-name")
    let bundleCount = $(this).attr("data-product-count")
    let itemsArray = [];
    $( "select.bundle_select" ).find(":selected").each(function( index,value ) {
       itemsArray.push(
         {
           quantity: 1,
           id: parseInt(this.value),
           properties: {
             '_bundle': "true",
             '_bundle_master_title': bundleTitle,
             '_bundle_discount': "20",
             "_bundle_price": dataBundlePrice,
             "_bundle_originalPrice": dataBundleCompareAtPrice,
             "_bundle_count": bundleCount
           }
         }
       );
    })
    $.ajax({
       type: 'POST', 
       url: '/cart/add.js',
       dataType: 'json', 
       data: { items: itemsArray },
       beforeSend: function() {
           $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
           $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
       },
       success: function(product) {
           $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeIn');
 
           window.setTimeout(function(){
             $addToCartBtn.removeAttr('disabled').removeClass('disabled');
             $addToCartBtn.find('span').addClass("fadeOut").removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
           }, 1000);
 
           $.ajax({
             url: '/cart.js',
             dataType: "json",
             cache: false,
             success: function(cart) {
               refreshCart(cart);
               window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);
             }
           });
       },
       error: function(XMLHttpRequest) {
           var response = eval('(' + XMLHttpRequest.responseText + ')');
           response = response.description;
           $('.warning').remove();
 
           var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
           $addToCartForm.after(warning);
           $addToCartBtn.removeAttr('disabled').removeClass('disabled');
           $addToCartBtn.find('span').removeClass('zoomOut').addClass('zoomIn');
         
       }
     });
     return false;
 })

$(document).on('change', '[data-cart-quantity-input-bundle]', function(e) {
  $(this).parents('.mm-counter').addClass('disabled');

  let data = { updates: {} };
  let $input = $(this);
  let newQty = $input.val();

  $input.parents('.mm-listview').find('[data-bundle-item]').each(function(index){
    data.updates[$(this).data('item-key')] = newQty;
  });
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (data) {
      refreshCart(data);
    }
  });
});

$(document).on("click", ".QuantitySelector__Button--bundle-minus", function(e) {
  var quantity = parseInt($(this).next("input").val());
  quantity -= 1;
  
  $(this).next("input").val(quantity).trigger('change');
  
  e.stopPropagation();
  e.preventDefault();
  return false;
});

$(document).on("click", ".QuantitySelector__Button--bundle-plus", function(e) {
  var quantity = parseInt($(this).prev("input").val());
  quantity += 1;
  $(this).prev("input").val(quantity).trigger('change');

  e.stopPropagation();
  e.preventDefault();
  return false;
});

$(document).on('blur', '.CartItem__edit--bundle', function(e) {
  e.preventDefault();
  console.log("123")
  $(this).parents('.editBundle').addClass('disabled');

  let data = { updates: {} };
  let $input = $(this);
  let newQty = $input.val();

  $input.parents('.cart_items').find('[data-bundle-item]').each(function(index){
    data.updates[$(this).data('item-key')] = newQty;
  });
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (data) {
      window.location.href = "/cart"
    }
  });
});

$('.CartItem__edit--bundle').keypress(function (e) {
 var key = e.which;
 if(key == 13)  // the enter key code
  {
    $(this).trigger('blur');
    return false;  
  }
}); 

$(document).on('click', '.CartItem__Remove--bundle', function (e) {
  e.preventDefault();
  $(this).parents('.editBundle').find('.CartItem__edit--bundle').val(0).trigger('blur');
});

                     